export const TEST_ID = 'assetModelSelector';

export const TOGGLE_TEST_ID = 'assetModelSelectorToggle';
